<template>
  <v-app>
<!--    app bar-->
    <v-app-bar app>
      <v-app-bar-nav-icon  v-if="user"  @click.stop="drawer = !drawer">
      <v-icon>view_headline</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <div @click="routeToLandingPage">
          <v-img
              src="./assets/Flexline Toolbar Logo(400 x 100 px).png"
              class="shrink mt-1 mb-5 mt-2"
              contain
              alt="Flexline"
              min-width="180"
              width="150"
          />
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!user" text outlined color="blue-grey darken-4" @click="route({route: '/signin', type: 'link'})">Signin</v-btn>
<!--lis tof items from right navbar button-->
      <div v-if="user" class="text-center justify-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on">
              <v-icon dark>mdi-account-details</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="routeToSettings">
              <v-list-item-title>Account Settings</v-list-item-title>
            </v-list-item>
            <v-list-item @click="signUserOut">
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>


    </v-app-bar>
<!--    nav drawer-->
    <v-navigation-drawer
        app
        v-if="user"
        v-model="drawer"
    >
      <v-list dense v-for="item in drawerItems"  :key="item.icon">
        <!--link to admin panel-->
        <v-list-item @click="route(item)" link>
          <v-list-item-action>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
<!--    main router view-->
      <v-main fluid>
          <router-view/>
      </v-main>
    <div style="height: 200px"></div>
<!--footer component-->
    <v-footer absolute padless>
<!--      <v-container fluid>-->
          <v-card
              class="flex"
          >

            <v-card-text class="py-2  text-center white--text grey darken-4">
              {{ new Date().getFullYear() }} —

              <a style="text-decoration:none"
                 class="white--text"
                 target="_blank"
                 href="https://flexline.app"
              >
                <strong>Flexline</strong>
              </a>
            </v-card-text>
          </v-card>
<!--      </v-container>-->
    </v-footer>

  </v-app>
</template>
<script>
// import {doc} from "firebase/firestore";

export default {
  data: () => ({
    drawer: false,
    drawerItems: [
      {title: 'Dashboard', route: '/', icon: 'mdi-view-dashboard-outline', type: 'link'},
      {title: 'Fulfillment', route: '/fulfillments', icon: 'work', type: 'link'},
      {title: 'Profile settings', route: '/editProfile', icon: 'mdi-account', type: 'link'},
      {title: 'Log out', route: '', icon: 'mdi-exit-to-app', type: 'method', method: 'signUserOut'},
    ]
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
  },
  watch: {
    user (value) {
      if (value == null) {
        this.drawer = false
      }
    }
  },
  methods: {
    routeToSettings () {
      this.$router.push('/editProfile')
    },
    routeToLandingPage () {
      this.$router.push('/')
    },
    signUserOut () {
     this.$store.dispatch('logout')
    },
    route (drawerItem) {
      if (drawerItem.type !== 'method') {
        this.$router.push(drawerItem.route)
      } else {
        if (drawerItem.method === 'signUserOut') {
          this.signUserOut()
        }
      }
    }
  }
}
</script>

